const RasterMapType = {
    Default: 'default',
    Light: 'light',
    Dark: 'dark',
    Hybrid: 'hybrid',
    Aerial: 'aerial',
    TransparentBackground: 'transparentBackground',
};

Object.freeze(RasterMapType);

export default RasterMapType;